import {
  Button,
  Input,
  Select,
  Divider,
  Dropdown,
  Menu,
  DatePicker,
  Col,
  Row,
} from 'antd'
import React, { useEffect, useState } from 'react'
import {
  SearchOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from '@ant-design/icons'
import {
  AGE_SEARCH_TYPE,
  SEARCH_QUERY_TYPE,
  COUNTRY_TYPE,
  GENDER_TYPE,
  PHONE_MODEL,
  PROVIDER_COUNTRY,
  appUsageReportFilters,
  GROUP_QUERY_TYPE,
  groupingFilters,
  source,
  mncmccOptions,
  userType,
} from 'src/constants'
import { searchPlaylistReport } from 'src/api/reports'
import { fetchCountryProvider } from 'src/api/authen'
import { UserNameAutoComplete } from 'src/components/Search/UserNameSearch'
import moment from 'moment'

interface UserJourneyReportSearchProps {
  appendSearchForm: (obj: any) => void
  submitSearchForm: () => void
}

const UserJourneyReportSearch: React.FC<UserJourneyReportSearchProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  const [loading, setLoading] = useState(false)
  const [searchType, setSearchType] = useState('Between')
  const [minAge, setMinAge] = useState('')
  const [maxAge, setMaxAge] = useState('')
  const [country, setCountry] = useState('')
  const [searchQueryType, setSearchQueryType] = useState([])
  const [gender, setGender] = useState('Male')
  const [deviceType, setdeviceType] = useState('')
  const [clientName, setClientName] = useState('')
  const [buttonAction, setButtonAction] = useState('Select')
  const [providerCountry, setProviderCountry] = useState('')
  const [userName, setUserName] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [groupQueryType, setgroupQueryType] = useState([])
  const [groupBy,setGroupBy] =useState('')
  const [countries, setCountries] = useState([])
  const [selectedFilterValue, setSelectedFilterValue] = useState('ALL');
  const handlePdfClick = () => {
    appendSearchForm({ buttonAction: 'Generate Pdf' })
    submitSearchForm()
  }

  const handleCsvClick = () => {
    appendSearchForm({ buttonAction: 'Generate Csv' })
    submitSearchForm()
  }
  const handleSearchClick = () => {
    appendSearchForm({ buttonAction: ' ' })
    submitSearchForm()
    setButtonAction(null)
  }

  const handleSearchTypeChange = (value: string) => {
    setSearchType(value)
    setMinAge('')
    setMaxAge('')
    setProviderCountry('')
    setUserName('')
    setStartDate('')
    setEndDate('')
  }

  const handleSearchQueryTypeChange = React.useCallback((opts: any[]) => {
    setSearchQueryType(opts)
    appendSearchForm({ searchQueryType })
  }, [])

  const filterCountryOption = (inputValue, option) => {
    return option.children.toLowerCase().includes(inputValue.toLowerCase())
  }
  const handleSearchQueryTypeDeselect = React.useCallback(
    (deselectedOption: any) => {
      const updatedOptions = searchQueryType.filter(
        (option) => option !== deselectedOption
      )

      switch (deselectedOption) {
        case 'By Age':
          appendSearchForm({ maxAge: '', minAge: '' })
          break
        case 'By Country':
          appendSearchForm({ country: '' })
          break
        case 'By Gender':
          appendSearchForm({ gender: '' })
          break
        case 'By Device Type':
          appendSearchForm({ deviceType: '' })
          break
        case 'By Provider':
          appendSearchForm({ providerCountry: '' })
          break
        case 'By User Name':
          appendSearchForm({ userName: '' })
          break
        case 'By Event Date':
          appendSearchForm({ startDate: '', endDate: '' })
          break
        default:
          break
      }

      appendSearchForm(updatedOptions)
      submitSearchForm()
    },
    [searchQueryType]
  )

  const handleSearchQueryTypeClear = React.useCallback(() => {
    appendSearchForm({
      searchQueryType: '',
      country: '',
      deviceType: '',
      gender: '',
      maxAge: '',
      minAge: '',
      buttonAction: '',
      providerCountry: '',
      userName: '',
      startDate: '',
      endDate: '',
    })

    submitSearchForm()
  }, [])
  const handleSearchTypeClear = React.useCallback(() => {
    appendSearchForm({
      maxAge: '',
      minAge: '',
      searchType: '',
      providerCountry: '',
      userName: '',
      startDate: '',
      endDate: '',
    })

    submitSearchForm()
  }, [])
  useEffect(() => {
    appendSearchForm({ maxAge: '' })
    appendSearchForm({ minAge: '' })
    appendSearchForm({ searchType })
    appendSearchForm({ providerCountry: '' })
    appendSearchForm({ userName: '' })
    appendSearchForm({ startDate: '' })
    appendSearchForm({ endDate: '' })
  }, [searchType])
  useEffect(() => {
    const fetchCountry = async () => {
             try {
               const data = await fetchCountryProvider()
               const countryOptions = data.data.map((item) => ({
                 label: item.countryName,
                 value: item.countryCode,
               }))
               setCountries(countryOptions)
             } catch (error) {
               console.error('Error fetching data:', error)
             }
           }
           fetchCountry()
  }, [])

  const handleGroupByClear = React.useCallback(() => {
    appendSearchForm({
     groupBy:''
    })

    submitSearchForm()
  }, [])
  const allUserTypeOptions = [
      { label: 'All', value: 'ALL' },
      ...userType,
    ];
const handleFilterChange = (value) => {
      setSelectedFilterValue(value);
      let userTypesForSearch;
  
      if (value === 'ALL') {
       
        userTypesForSearch = userType.map(option => option.value);
      } else {
        
        userTypesForSearch = [value];
      }
  
      appendSearchForm({ userAccessType: userTypesForSearch });
      
    };
  return (
     
      
      <div className="master-search-wrap">
       <Row gutter={5}>
      
      <Col span={4}>
         <UserNameAutoComplete  appendSearchForm={appendSearchForm} />
      
       </Col>
       <Col span={4}>
        <Select
          placeholder="Select User Type"
          onChange={handleFilterChange}
          onClear={() => {
            
            appendSearchForm({ userAccessType: '' });
            
          }}
         
          className="search-input"
        >
          {allUserTypeOptions.map(({ label, value }) => (
            <Select.Option value={value} key={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </Col>
       <Col span={10}>
          <DatePicker.RangePicker
           
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            onChange={(dates) => {
              appendSearchForm({
                startDate: dates[0] ? dates[0].format('YYYY-MM-DD') : moment().subtract(7, 'days').format('YYYY-MM-DD'),
                endDate: dates[1] ? dates[1].format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
              })
            }}
          />
        </Col>
      
        
     <Col span={4}>
           <Select
             placeholder="Provider Country"
             onChange={(value) => {
               appendSearchForm({ providerCountry: value });
               if (!value) submitSearchForm();
             }}
             allowClear
             onClear={() => {
               appendSearchForm({ providerCountry: '' });
               submitSearchForm();
             }}
             showSearch
             className="search-input"
             style={{ width: '100%' }}
           >
             {countries.map((country) => (
               <Select.Option value={country.value} key={country.value}>
                 {country.label}
               </Select.Option>
             ))}
           </Select>
         </Col>
         <Col span={4}>
        <Select
          placeholder="Select Gender"
          onChange={(value) => appendSearchForm({ gender: value })}
          allowClear
          onClear={() => appendSearchForm({ gender: '' })}
          className="search-input"
        >
          {GENDER_TYPE.map((val) => (
            <Select.Option value={val} key={val}>
              {val}
            </Select.Option>
          ))}
        </Select>
     </Col>
     <Col span={4}>
        <Select
          placeholder="Select Device Type"
          onChange={(value) => appendSearchForm({ deviceType: value })}
          allowClear
          onClear={() => appendSearchForm({ deviceType: '' })}
          className="search-input"
        >
          {PHONE_MODEL.map(({label,value}) => (
                      <Select.Option value={value} key={value}>
                        {label}
                      </Select.Option>
                    ))}
        </Select>
        </Col>
      

      
      <Col span={4}>
          <Select
          placeholder="Source "
          onChange={(value) => {
            appendSearchForm({ mncmcc: value });
            if (!value) submitSearchForm();
          }}
          allowClear
          onClear={() => {
            appendSearchForm({ mncmcc: '' });
            submitSearchForm();
          }}
          showSearch
          className="search-input"
          style={{ width: '100%' }}
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() || '').includes(input.toLowerCase())
          }
        >
          {mncmccOptions.map(({ value, label }) => (
            <Select.Option value={value} key={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
          </Col>
          <Col span={4}>
      <Button
        type="primary"
        icon={<SearchOutlined />}
        onClick={handleSearchClick}
        className="btn-primary"
       
      >
        Search
      </Button>
      </Col>
      </Row>
       

     
    
    
    </div>
  )
}

UserJourneyReportSearch.displayName = 'UserJourneyReportSearch'
export default UserJourneyReportSearch
